
const isPreviewMode = (new URLSearchParams(window.location.search)).get('preview') === "1"
const seed = ~~(fxrand() * 123456789)


let module=import('../wasm-lib/pkg').then((module) => {
    var canvas = document.createElement("canvas");
    document.body.appendChild(canvas);
    canvas.height = window.innerHeight
    canvas.width = window.innerWidth
    var context=canvas.getContext("2d")
    var solar_system=null;
    

    function draw(){
        context.fillStyle = "#FFFFFF";
        context.fillRect(0, 0, canvas.width, canvas.height)
        solar_system.next(0,context)
        window.requestAnimationFrame(draw)
    
    }

    window.addEventListener('resize', () => {
        canvas.width = window.innerWidth
        canvas.height = window.innerHeight
        start()
    })
    
    function start() {
        var ctx = canvas.getContext("2d");
        solar_system=new module.SolarSystem(canvas.width,canvas.height,BigInt(seed))
        ctx.fillStyle = "#FFFFFF";
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        window.requestAnimationFrame(draw)
    
    
    }
    start()
})    














